import React from "react"
import Dot from "./Dot"


export default function FirstFace(){
    return(
        <div className="dice first-face">
            <Dot />
        </div>
    )
}